import { render, staticRenderFns } from "./QuestionTutorial.vue?vue&type=template&id=2c6c5d45&scoped=true&"
import script from "./QuestionTutorial.vue?vue&type=script&lang=ts&"
export * from "./QuestionTutorial.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTutorial.vue?vue&type=style&index=0&id=2c6c5d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c5d45",
  null
  
)

export default component.exports